import { Actions } from './index';
import * as Yup from 'yup';

export type Settings = {
  // Add cover page to Fax Request
  addCoverPage?: boolean,
  // Allow recipients to be reordered on "Add signers" page
  recipientOrder?: boolean,
  // Allow QES
  qes?: boolean,
  // Allow recipient reassignment checkbox on "Add signers" page
  recipientReassignment?: boolean,
  // Show modal for user to enter first&last name when sending request
  requireSignerInfo?: boolean,
  // Send high quality fax
  sendHighResFax?: boolean,
  // User agreed to flags.needsCharge
  needsCharge?: boolean,
};

export const settingsSchema = Yup.object<Settings>({
  addCoverPage: Yup.boolean(),
  recipientOrder: Yup.boolean(),
  qes: Yup.boolean(),
  recipientReassignment: Yup.boolean(),
  requireSignerInfo: Yup.boolean(),
  sendHighResFax: Yup.boolean(),
});

const updateAccountParamsSchema = Yup.object({
  firstName: Yup.string(),
  lastName: Yup.string(),
  alwaysSendMeACopy: Yup.boolean(),
  alwaysSendOthersACopy: Yup.boolean(),
});

export type UpdateAccountParams = Yup.InferType<typeof updateAccountParamsSchema>

export type UpdateAccountResponse = {
  success: boolean,
}

export interface UpdateSettingsAction {
  type: Actions.UpdateSettings,
  payload: Partial<Settings>,
}

export type SettingsActions =
  | UpdateSettingsAction
